import {useMemo} from 'react'
import {Accordion, AccordionSummary, AccordionDetails, Typography} from '@mui/material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import VideocamIcon from '@mui/icons-material/Videocam'
import {useTranslation} from 'react-i18next'
import {useAppTokens} from '../../theme'
import type {ThemeTokens} from '../../theme'
import CameraPresetGrid from '../topMenuBar/CameraPresetGrid'

// ── CameraPresetsPanel — sub-accordion wrapping the preset grid ────

const CameraPresetsPanel = () => {
  const {t} = useTranslation()
  const tokens = useAppTokens()
  const sx = useMemo(() => buildStyles(tokens), [tokens])

  return (
    <Accordion disableGutters square sx={sx.subAccordion}>
      <AccordionSummary expandIcon={<ExpandMoreIcon sx={sx.expandIcon} />} sx={sx.subSummary}>
        <VideocamIcon sx={sx.subIcon} />
        <Typography sx={sx.subTitle}>{t('scene.camera.presets')}</Typography>
      </AccordionSummary>
      <AccordionDetails sx={sx.subDetails}>
        <CameraPresetGrid />
      </AccordionDetails>
    </Accordion>
  )
}

const buildStyles = (tokens: ThemeTokens) => ({
  subAccordion: {
    backgroundColor: 'transparent',
    boxShadow: 'none',
    '&:before': {display: 'none'},
    '&.Mui-expanded': {margin: 0},
  },
  subSummary: {
    minHeight: 40,
    padding: '0 4px',
    '&.Mui-expanded': {minHeight: 40},
    '& .MuiAccordionSummary-content': {
      margin: '8px 0',
      alignItems: 'center',
      gap: '6px',
      '&.Mui-expanded': {margin: '8px 0'},
    },
  },
  expandIcon: {
    color: tokens.accordion.expandIcon,
    fontSize: 18,
  },
  subIcon: {
    color: tokens.accordion.sectionIcon,
    fontSize: 16,
  },
  subTitle: {
    fontSize: 12,
    fontWeight: 600,
    textTransform: 'uppercase' as const,
    letterSpacing: '0.04em',
    color: tokens.text.secondary,
  },
  subDetails: {
    padding: '4px 4px 12px',
  },
})

export default CameraPresetsPanel
